import Vue from 'vue'

import uiTagsItem from './src/ui-tags-item.vue';
import uiTagsSimpleList from './src/ui-tags-simple-list.vue';
import uiTags from './src/ui-tags.vue';

var components = [
  uiTagsItem,
  uiTagsSimpleList,
  uiTags
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-tags/index.js
// module id = 560
// module chunks = 0